import React, { Component } from 'react'
import { connect } from 'react-redux'

import CssBaseline from '@material-ui/core/CssBaseline'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName } from '@material-ui/core/styles'

import BkFlowContent from './structure/BkFlowContent'
import BkFlowError from '../components/elements/BkFlowError'
import BkFlowLoader from '../components/elements/BkFlowLoader'
import BkFlowSessionModal from '../components/structure/session/BkFlowSessionModal'

// import getCookie from '../utilities/session/getCookie'
import eraseCookie from '../utilities/session/removeCookie'

import yn from 'yn'
import _ from 'lodash'

const generateClassName = createGenerateClassName({
	dangerouslyUseGlobalCSS: true,
})

class App extends Component {
	constructor(props) {
		super(props)
		const baseTimeOut = process.env.REACT_APP_COMPONENT_SESSION_TIMEOUT_DURATION || 900

		this.state = {
			sessionTimer: Number(baseTimeOut)
		}
	}

	timer() {
		let newCount = this.state.sessionTimer - 1

		if (newCount >= 0) {
			this.setState({ sessionTimer: newCount })
		} else {
			clearInterval(this.state.intervalId)
		}
	}

  componentDidMount() {
	  // Import Query string & Parse URL
	  const queryString = require('query-string')
	  const urlQuery = queryString.parse(window.location.search)

		// automatically set exactMatchOnly to true when query params contain promoCode
	  if (urlQuery.promoCode && urlQuery.exactMatchOnly !== 'true') {
		  const params = new URLSearchParams(window.location.search)
		  params.set('exactMatchOnly', 'true')
		  window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`)
		  urlQuery.exactMatchOnly = 'true'
	  }

	  const queryParams = window.localStorage.getItem('flowCurrentQuery')

		if (urlQuery && !localStorage.getItem('flowGuestData')) {
			localStorage.setItem('flowGuestData', JSON.stringify({
				0: {
					adults: parseInt(urlQuery.adults, 10) || 1,
					children: parseInt(urlQuery.children, 10) || 0,
					dogs: false,
					cats: false,
				},
			}))
		}

	  // const queryParams = getCookie('flowCurrentQuery')
	  if (queryParams) {
		  window.history.pushState( {} , '', '/book?' + queryParams)

		  setTimeout(function() {
			  window.localStorage.removeItem('flowCurrentQuery')
		  	eraseCookie('flowCurrentQuery')
		  }, 1000)
	  }

	  let appMain = document.getElementById('bk-flow__main')

	  // Set brand-level class for theme styles
	  if (
	  	urlQuery.theme &&
		  urlQuery.theme !== '' &&
		  urlQuery.theme !== 'null'
	  ) {
		  document.body.classList.add(urlQuery.theme)
	  }

	  // Set sticky-nav class based on ENV boolean
	  if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
		  appMain.classList.add('sticky-nav')
	  }

	  if (
	  	yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
		  yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)
	  ) {
		  appMain.classList.add('inc-utility')
	  }

	  this.intervalId = setInterval(this.timer.bind(this), 1000)
  }

	componentWillUnmount(){
		clearInterval(this.intervalId);
	}

	render() {
		const {
			configData,
			configLoading,
			configError,
			availabilityData
		} = this.props

		const appMain = document.getElementById('bk-flow__main')
		const hasMaintenanceMessage = _.get(availabilityData, 'availability[0][0].viewExtensions.bookingMessages')

		if (hasMaintenanceMessage) {
			appMain.classList.add('inc-maintenance-banner')
		}

		return (
			<JssProvider generateClassName={ generateClassName }>
				<div
					id="bk-flow__main"
					className="bk-flow__main"
				>
					<CssBaseline />

					{ configLoading ?
						<BkFlowLoader />
					: configError ?
						<BkFlowError
							configData={ configData}
							availabilityData={ availabilityData }
							requestError={ configError }
						/>
					:
						<BkFlowContent />
					}
					{yn(process.env.REACT_APP_COMPONENT_ENABLE_SESSION_TIMEOUT) &&
					this.state.sessionTimer === 0 &&
						<BkFlowSessionModal configData={configData} />
					}
				</div>
			</JssProvider>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	configLoading: state.configData.loading,
	configError: state.configData.error,
	availabilityData: state.availabilityData
})

export default connect(mapStateToProps, null)(App)


// WEBPACK FOOTER //
// ./src/containers/App.js